// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { AssetFragmentDoc } from '../../../fragments/asset.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from './stoneShapeTranslation.fragment.generated';
export const StoneShapeFragmentDoc = `
    fragment stoneShape on StoneShape {
  systemCode
  icon {
    ...asset
  }
  samplePhoto {
    ...asset
  }
  translation(locale: $locale) {
    ...stoneShapeTranslation
  }
}
    `;